import React from "react";

const getPageNumbers = (current, total) => {
  const delta = 1;
  const pages = [];

  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      pages.push(i);
    }
  }

  const pagesWithEllipsis = [];
  let previous = null;
  pages.forEach((i) => {
    if (previous !== null && i - previous > 1) {
      pagesWithEllipsis.push("...");
    }
    pagesWithEllipsis.push(i);
    previous = i;
  });

  return pagesWithEllipsis;
};

// Items-per-page + page number footer shared by the checker tables. The parent
// owns page / limit so it can slice its own rows.
function CheckerPagination({ page, limit, totalCount, onPageChange, onLimitChange }) {
  const totalPages = Math.ceil(totalCount / limit);

  return (
    <div className="d-flex align-items-center justify-content-between pagination-wrapper">
      <div className="pagination-left d-flex align-items-center">
        <span className="items-label">Items per page</span>

        <select
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          className="page-select"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>

        <span className="page-count">
          {totalCount === 0
            ? "0-0 items"
            : `${(page - 1) * limit + 1}-${Math.min(page * limit, totalCount)} of ${totalCount} items`}
        </span>
      </div>

      <div className="pagination-right d-flex align-items-center">
        <button
          type="button"
          className="pagination-btn"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          &lt;
        </button>

        {getPageNumbers(page, totalPages).map((item, index) =>
          item === "..." ? (
            <span key={`dots-${index}`} className="pagination-dots">
              ...
            </span>
          ) : (
            <button
              type="button"
              key={item}
              className={`pagination-number ${page === item ? "active-page" : ""}`}
              onClick={() => onPageChange(item)}
            >
              {item}
            </button>
          )
        )}

        <button
          type="button"
          className="pagination-btn"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          &gt;
        </button>
      </div>
    </div>
  );
}

export default CheckerPagination;
